<template>
  <div id="graphs-dashboard">
    <h5>{{$t('dashboard_new_evollu.titles.parameters')}} </h5>

    <div v-if="isLoading" class="d-flex align-items-center flex-column py-5">
      <span class="mb-3">{{$t('agenda.statistics.loading')}}</span>
      <hollow-dots-spinner
        :animation-duration="1000"
        :size="60"
        color="#29c4a9"
      />
    </div>
    <div v-else>
      <div v-if="graphsDataArrayParsed.length" class="row mt-4">
        <div v-for="graph in graphsDataArrayParsed" class="col-12 col-sm-3 col-md-3">
          <HorizontalDonutChartWidgetV2
            :title="graph.parameterType"
            :hidePercentage="true"
            :data="graph.data"
            :options="options"
          >
          </HorizontalDonutChartWidgetV2>
        </div>
      </div>
      <div v-else class="text-center py-5">
        <span class="mb-3 is-bold">{{ $t('dashboard_new_evollu.values.empty_graphs') }}</span>
      </div>
      <ResultTypePatientsModal
        v-if="resultTypeId"
        :resultTypeId="resultTypeId"
        :facilityId="facilityId"
        :titleMeasurementType="titleMeasurementType"
        :titleResultType="titleResultType"
        :period="filters.period"
        @cancel="onCancel"
        @row-clicked="onRowClicked"
      />
    </div>


  </div>
</template>

<script>
import HorizontalDonutChartWidgetV2 from '@/components/common/statistics/HorizontalDonutChartWidgetV2';
import { OneCareService } from '@/api/OneCareService';
import { HollowDotsSpinner } from 'epic-spinners';
import ResultTypePatientsModal from '@/components/checkup_plus/dashboard/ResultTypePatientsModal.vue';
import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
import Multiselect from 'vue-multiselect';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';

export default {
  name: "GraphsDashboard",
  components: {
    Multiselect, RangeDatePicker,
    HorizontalDonutChartWidgetV2,
    HollowDotsSpinner,
    ResultTypePatientsModal,
  },
  mixins: [
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  props:{
    hasWritePermission: {
      type: Boolean,
      default: false,
      required: true
    },
    readableFacilities: {
      type: Array,
      default: [],
      required: true
    },
    timePeriods: {
      type: Array,
      default: [],
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      graphsDataArray: [],
      options: {
        onClick: (evt, elementClicked) => {
          if(!this.hasWritePermission) {
            return
          }
          this.$emit('pieGraphClicked', elementClicked)
        }
      },
      resultTypeId: null,
      facilityId: null,
      titleResultType: null,
      titleMeasurementType: null
    }
  },
  mounted() {
    this.$on('pieGraphClicked', (elementClicked) => {
      if (elementClicked[0]) {
        const i = elementClicked[0]._index;
        this.resultTypeId = elementClicked[0]._chart.data.resultTypes[i];
        this.titleResultType = elementClicked[0]._chart.data.labels[i];
        this.titleMeasurementType = elementClicked[0]._chart.data.graphTitle;
        this.facilityId = this.filters.facility.id;
      } else {
        this.resultTypeId = null;
        this.facilityId = null;
      }
    })
  },
  computed: {
    graphsDataArrayParsed: function() {
      return this.graphsDataArray.map(graph => {
        return {
          "parameterType": this.$t(`dashboard_new_evollu.parameters.graphs.titles.${graph.chartCode.toLowerCase()}`),
          "data": {
            graphTitle: this.$t(`dashboard_new_evollu.parameters.graphs.titles.${graph.chartCode.toLowerCase()}`),
            warning: false,
            labels: graph.dashboardValues.map(value => this.$t(`dashboard_new_evollu.parameters.graphs.legends.${value.code.toLowerCase()}_short`)),
            resultTypes: graph.dashboardValues.map(value => value.resultTypeId),
            datasets: [{
              data: graph.dashboardValues.map(value => value.numberCases),
              backgroundColor: graph.dashboardValues.map(value => value.hexadecimalColorCode ? value.hexadecimalColorCode : '#'+(Math.random()*0xFFFFFF<<0).toString(16)),
            }]
          }
        }
      })
    },
  },
  watch:{
    filters: {
      handler: function (val) {
        if(this.filters.facility && this.filters.period) {
          this.getDataGraphs();
        } else {
          this.graphsDataArray = []
        }

      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    formatDate(initial) {
      return initial.replaceAll("-", "/");
    },
    async getDataGraphs() {
      this.isLoading = true;
      try {
        this.graphsDataArray = await OneCareService.getGraphs(
          this.filters.facility.id,
          this.filters.period.id
        )
      } catch (err) {
        this.showToast(this.$t('dashboard_new_evollu.errors.loading_graphs'), this.$store.state.errorToastOptions)
        this.graphsDataArray = []
      } finally {
        this.isLoading = false;
      }
    },
    onCancel() {
      this.resultTypeId = null;
      this.facilityId = null;
    },
    onRowClicked(row) {
      this.onCancel()
      this.$router.push({name: `check-up_plus/checkup_plus/patients/id`, params: {id: row.idPerson}})
    }
  }
}

</script>

<style scoped>
</style>
